function cleanMenuItemNames() {
  $('.custom-sub-menu-child').each(function() {
    var text = $(this).text().trim();
    if (text.includes('_')) {
      var newText = text.split('_')[1]; // Gets the part after the underscore
      $(this).text(newText);
    }
  });
}

// Run the function when the document is ready
$(document).ready(function() {
  cleanMenuItemNames();
});


     

 var classLength = $('.previous-pagination').length;
if(classLength >= 2){
    $('.pagination__list li:nth-child(2)').remove();
}
      //HamburgerScript
       $('#toggle').click(function() {
    $(this).toggleClass('active-menu');
    $('#overlay').toggleClass('open');
});
// AddClassinBodyTag
$('.button_container').click(function() {
    if ($('body').hasClass('extra-class')) {
        $('body').removeClass('extra-class');
    } else {
        $('body').addClass('extra-class');
    }
});
// AddClassinHTMlTag
$('.button_container').click(function() {
    if ($('html').hasClass('overflow-hide')) {
        $('html').removeClass('overflow-hide');
    } else {
        $('html').addClass('overflow-hide');
    }
});

      // SLIDER--JS--STARTS

      $(document).ready(function() {
    // Swiper: Slider
        new Swiper('.swiper-container', {
            // loop: true,
            infinite: true,
            autoplay: false,
            nextButton: '.swiper-button-next',
            prevButton: '.swiper-button-prev',
            slidesPerView: 5.4,
            paginationClickable: true,
            spaceBetween: 43,
            breakpoints: {
                1916: {
                    slidesPerView: 4.4,
                    spaceBetween: 43
                },
                1370: {
                    slidesPerView: 3.4,
                    spaceBetween: 20
                },
                860: {
                    slidesPerView: 2.2,
                    spaceBetween: 30
                },
                600: {
                    slidesPerView: 2.2,
                    spaceBetween: 20
                },
                560: {
                    slidesPerView: 1.5,
                    spaceBetween: 20
                },
                440: {
                    slidesPerView: 1.4,
                    spaceBetween: 20
                },
                390: {
                    slidesPerView: 1.1,
                    spaceBetween: 20
                }
            }
        });
    });




      $(document).ready(function(){
            $('.best-col-prod').slick({
              infinite: false,
              dots: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
      {
        breakpoint: 870,  
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 772,  
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 550,  
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
            });
          });




          $('.toddler-slider').slick({
            centerMode: true,
            centerPadding: '20px',
            slidesToShow: 4.6,
            arrows: false,
            autoplay: false,
            infinite: true,
            autoplaySpeed: 2000,
             responsive: [
      {
        breakpoint: 992,  
        settings: {
          slidesToShow: 2.6,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 550,  
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
          });
 // ALL--SLIDER--JS--ENDS



  $(document).ready(function () {
    // Get stock quantity from the data attribute
    var stockQuantity = parseInt($('#add-to-cart-button').data('stock'), 10);

    // Check stock and update the button
    if (stockQuantity <= 0) {
      $('#add-to-cart-button')
        .prop('disabled', true) // Disable the button
        .text('Out of Stock')   // Change button text
        .css('cursor', 'not-allowed'); // Update cursor style
    }
  });




      // Left-offside-container
jQuery(document).ready(function(){
    if (jQuery(window).width() > 767) {
        var offset = jQuery('.left-offset').offset().left;
        jQuery('.auto-container').css('padding-left', offset);
    }
});

jQuery(window).resize(function(){
    if (jQuery(window).width() > 767) {
        var offset = jQuery('.left-offset').offset().left;
        jQuery('.auto-container').css('padding-left', offset);
    }
});




  ///// MEGA---MENU----JS ////
function initializeMenu() {
    const screenWidth = window.innerWidth;

    if (screenWidth >= 769) {
        // Get all menu list items (li) in the main menu
        const menuItems = document.querySelectorAll('.main-menu > li');

        menuItems.forEach(item => {
            const menuLinks = item.querySelectorAll('.sub-menu a');
            const productItems = item.querySelectorAll('.all-shirt-products > div');
            const menuHolder = item.querySelector('.sub-menu-main-holder');

            // Function to deactivate all product items within the current menu item
            function deactivateItems() {
                productItems.forEach(productItem => productItem.classList.remove('active'));
            }

            // Function to activate the first product item within the current menu item
            function activateFirstItem() {
                const firstItem = productItems[0];
                if (firstItem) {
                    firstItem.classList.add('active');
                }
            }

            // Add hover event listener to each menu link within the current menu item
            menuLinks.forEach(link => {
                link.addEventListener('mouseover', function(event) {
                    event.preventDefault(); // Prevent default link behavior

                    // Deactivate all items within this menu item
                    deactivateItems();

                    // Get the ID of the item to be activated
                    const targetId = link.getAttribute('data-id');

                    // Find the corresponding product item within this menu item and activate it
                    const targetItem = item.querySelector(targetId);
                    if (targetItem) {
                        targetItem.classList.add('active');
                    }
                });
            });

            // Check if menuHolder exists before adding mouseleave event
            if (menuHolder) {
                menuHolder.addEventListener('mouseleave', function() {
                    // Deactivate all items within this menu item
                    deactivateItems();

                    // Activate the first product item within this menu item
                    activateFirstItem();
                });
            }

            // Activate the first product item by default within this menu item
            activateFirstItem();
        });
    }
}
// Run the function on page load
initializeMenu();

// Run the function on window resize
window.addEventListener('resize', initializeMenu);

document.addEventListener('DOMContentLoaded', function () {
  const quickViewButtons = document.querySelectorAll('.quick-view');
  const modal = document.getElementById('quick-view-modal');
  const closeBtn = modal.querySelector('.close-quick-view');

  let sliderImages = [];
  let currentImageIndex = 0;

  function initImageSlider(images) {
    sliderImages = images;
    currentImageIndex = 0;
    renderSliderImage();
  }

  function renderSliderImage() {
    const slider = modal.querySelector('.slider');
    if (!slider || sliderImages.length === 0) return;
    slider.innerHTML = '';
    const img = document.createElement('img');
    img.src = sliderImages[currentImageIndex];
    img.alt = 'Product image';
    img.style.maxWidth = '100%';
    img.style.borderRadius = '8px';
    img.style.transition = 'opacity 0.3s ease-in-out';
    slider.appendChild(img);
  }

  modal.addEventListener('click', function (e) {
    if (e.target.closest('.slider-next')) {
      if (sliderImages.length === 0) return;
      currentImageIndex = (currentImageIndex + 1) % sliderImages.length;
      renderSliderImage();
    }

    if (e.target.closest('.slider-prev')) {
      if (sliderImages.length === 0) return;
      currentImageIndex = (currentImageIndex - 1 + sliderImages.length) % sliderImages.length;
      renderSliderImage();
    }
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      modal.style.display = 'none';
    });
  }

  window.addEventListener('click', function (event) {
    if (event.target === modal) {
      modal.style.display = 'none';
    }
  });

  quickViewButtons.forEach(button => {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      const productHandle = this.getAttribute('data-product-handle');
      if (!productHandle) return console.error('Missing product handle');

      fetch(`/products/${productHandle}.js`)
        .then(response => response.json())
        .then(product => {
          if (!modal) return console.error('Modal not found');

          modal.querySelector('.quick-view-product-title').textContent = product.title;
          modal.querySelector('.quick-view-product-price').textContent = `$${(product.price / 100).toFixed(2)}`;
          modal.querySelector('.quick-view-product-description').innerHTML = product.description;

          const variantInput = modal.querySelector('.quick-view-product-id');
          if (variantInput) variantInput.value = product.variants[0].id;

          const atcButton = modal.querySelector('.quick-view-add-to-cart');
          const productTags = (product.tags || []).map(t => t.toLowerCase());

          if (productTags.includes('in-store')) {
            atcButton.setAttribute('disabled', 'disabled');
            atcButton.textContent = 'Available in store';
          } else {
            atcButton.removeAttribute('disabled');
            atcButton.textContent = 'Add to Cart';
          }

          const slider = modal.querySelector('.slider');
          const prevButton = modal.querySelector('.slider-prev');
          const nextButton = modal.querySelector('.slider-next');

          if (slider) {
            const uniqueImages = [];
            const seen = new Set();

            product.variants.forEach(variant => {
              const imgSrc = variant.featured_image?.src;
              if (imgSrc && !seen.has(imgSrc)) {
                seen.add(imgSrc);
                uniqueImages.push(imgSrc);
              }
            });

            initImageSlider(uniqueImages);

            if (prevButton && nextButton) {
              if (uniqueImages.length <= 1) {
                prevButton.style.display = 'none';
                nextButton.style.display = 'none';
              } else {
                prevButton.style.display = 'block';
                nextButton.style.display = 'block';
              }
            }
          }

          const variantsContainer = modal.querySelector('.quick-view-variants');
          const sizeContainer = modal.querySelector('.quick-view-size-options');
          if (!variantsContainer || !sizeContainer) return;
          variantsContainer.innerHTML = '';
          sizeContainer.innerHTML = '';

          const metafieldScript = document.getElementById(`product-colors-json-${product.handle}`);
          const colors = metafieldScript ? JSON.parse(metafieldScript.textContent) : [];

          const optionNames = product.options.map(opt => opt.name.toLowerCase());
          const hasColor = optionNames.includes('color');
          const hasSize = optionNames.includes('size');
          const colorIndex = optionNames.indexOf('color') + 1;
          const sizeIndex = optionNames.indexOf('size') + 1;

          if (hasColor) {
            const colorList = document.createElement('ul');
            colorList.className = 'product-color-list';
            colorList.style.margin = '10px 0';
            colorList.style.padding = '0';

            const shownColors = new Set();
            let firstSwatchSelected = false;

            product.variants.forEach(variant => {
              const colorVal = variant[`option${colorIndex}`];
              if (!colorVal || shownColors.has(colorVal.toLowerCase())) return;
              shownColors.add(colorVal.toLowerCase());

              const li = document.createElement('li');
              li.style.display = 'inline-block';
              li.style.margin = '4px';

              const swatch = document.createElement('span');
              const metafieldColor = colors.find(c => c.name.toLowerCase() === colorVal.toLowerCase());
              const backgroundColor = metafieldColor?.color || '#ccc';

              swatch.className = 'color-swatch';
              swatch.style.backgroundColor = backgroundColor;
              swatch.title = colorVal;
              swatch.setAttribute('data-color', colorVal.toLowerCase());

              swatch.addEventListener('click', () => {
                const selectedColor = colorVal.toLowerCase();

                const allSwatches = colorList.querySelectorAll('span[data-color]');
                allSwatches.forEach(s => s.classList.remove('selected'));

                swatch.classList.add('selected');

                const defaultVariant = product.variants.find(v =>
                  v[`option${colorIndex}`]?.toLowerCase() === selectedColor
                );
                if (defaultVariant) {
                  variantInput.value = defaultVariant.id;
                }

                const allSizes = [...new Set(product.variants.map(v => v[`option${sizeIndex}`]))];
                sizeContainer.innerHTML = '';

                allSizes.forEach(sizeVal => {
                  const matchingVariant = product.variants.find(v =>
                    v[`option${colorIndex}`]?.toLowerCase() === selectedColor &&
                    v[`option${sizeIndex}`] === sizeVal
                  );

                  const btn = document.createElement('button');
                  btn.textContent = sizeVal;
                  btn.className = 'size-button';

                  if (matchingVariant) {
                    btn.dataset.variantId = matchingVariant.id;
                    if (!matchingVariant.available) {
                      btn.disabled = true;
                      btn.classList.add('unavailable');
                    }

                    btn.onclick = () => {
                      if (!matchingVariant.available) return;
                      variantInput.value = matchingVariant.id;

                      const allSizeButtons = sizeContainer.querySelectorAll('.size-button');
                      allSizeButtons.forEach(b => b.classList.remove('selected'));
                      btn.classList.add('selected');
                    };
                  } else {
                    btn.disabled = true;
                    btn.classList.add('unavailable');
                  }

                  sizeContainer.appendChild(btn);
                });
              });

              li.appendChild(swatch);
              colorList.appendChild(li);

              if (!firstSwatchSelected) {
                swatch.click();
                firstSwatchSelected = true;
              }
            });

            variantsContainer.appendChild(colorList);
          }

          if (hasSize && !hasColor) {
            const sizeSet = new Set();
            sizeContainer.innerHTML = '';

            product.variants.forEach(variant => {
              const sizeVal = variant[`option${sizeIndex}`];
              if (!sizeVal || sizeSet.has(sizeVal)) return;
              sizeSet.add(sizeVal);

              const btn = document.createElement('button');
              btn.textContent = sizeVal;
              btn.className = 'size-button';

              const match = product.variants.find(v => v[`option${sizeIndex}`] === sizeVal);

              if (match) {
                btn.dataset.variantId = match.id;
                if (!match.available) {
                  btn.disabled = true;
                  btn.classList.add('unavailable');
                }

                btn.onclick = () => {
                  if (!match.available) return;
                  variantInput.value = match.id;

                  const allSizeButtons = sizeContainer.querySelectorAll('.size-button');
                  allSizeButtons.forEach(b => b.classList.remove('selected'));
                  btn.classList.add('selected');
                };
              }

              sizeContainer.appendChild(btn);
            });
          }

          const quantityInput = modal.querySelector('.quantity__input');
          const minus = modal.querySelector('.quantity-minus');
          const plus = modal.querySelector('.quantity-plus');
          if (quantityInput) {
            quantityInput.value = 1;
            const updateMinus = () => minus.disabled = parseInt(quantityInput.value) <= 1;
            updateMinus();
            minus.onclick = () => {
              let val = parseInt(quantityInput.value);
              if (val > 1) quantityInput.value = val - 1;
              updateMinus();
            };
            plus.onclick = () => {
              quantityInput.value = parseInt(quantityInput.value) + 1;
              updateMinus();
            };
          }

          modal.style.display = 'block';
        })
        .catch(err => console.error('Quick view error:', err));
    });
  });
});

// SCRIPT--FOR--UPDATING--CART--FOR--CUSTOM--PRODUCT
document.addEventListener('DOMContentLoaded', function() {
    function updateCartCount() {
        fetch('/cart.js')
        .then(response => response.json())
        .then(data => {
            const cartCountElement = document.querySelector('.cart-count-bubble');
            if (cartCountElement) {
                cartCountElement.textContent = data.item_count;
                
                // Show/hide the bubble based on the cart count
                if (data.item_count > 0) {
                    cartCountElement.style.display = 'flex';
                } else {
                    cartCountElement.style.display = 'none';
                }
            }
        })
        .catch(error => console.error('Error fetching cart:', error));
    }

    document.querySelectorAll('.add-to-cart').forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            const productId = this.getAttribute('data-product-id');

            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    id: productId,
                    quantity: 1
                })
            })
            .then(response => response.json())
            .then(data => {
                // Update cart count
                updateCartCount();

                // Show pop-up notification
                const notification = document.getElementById('cart-notification');
                notification.style.display = 'block';
                setTimeout(() => {
                    notification.style.display = 'none';
                }, 3000);
            })
            .catch(error => {
                console.error('Error:', error);
            });
        });
    });

    document.querySelectorAll('.buy-now').forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            const productId = this.getAttribute('data-product-id');

            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    id: productId,
                    quantity: 1
                })
            })
            .then(response => response.json())
            .then(data => {
                // Redirect to checkout
                window.location.href = '/checkout';
            })
            .catch(error => {
                console.error('Error:', error);
            });
        });
    });

    // Update cart count on page load
    updateCartCount();
});



document.addEventListener('click', function(event) {
    if (event.target.classList.contains('cart__remove')) {
        event.preventDefault();

        let lineItemKey = event.target.getAttribute('data-cart-item-key'); 

        fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: lineItemKey, quantity: 0 })
        })
        .then(response => response.json())
        .then(cart => {
            location.reload(); // Refresh the cart after removal
        })
        .catch(error => console.error('Error removing item:', error));
    }
});




document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("cart-remove-button a.button").forEach(button => {
        button.addEventListener("click", function (event) {
            event.preventDefault();

            let parentItem = this.closest(".cart__items");
            parentItem.classList.remove("cart__items--disabled"); // Remove the disable class if present

            fetch(this.href, {
                method: "POST"
            })
            .then(response => {
                if (!response.ok) throw new Error("Network response was not ok");
                return response.json();
            })
            .then(data => {
                console.log("Item removed", data);
                location.reload();  // Refresh cart after removal
            })
            .catch(error => console.error("Error removing item:", error));
        });
    });
});



document.addEventListener("DOMContentLoaded", function () {
  // Handle Remove Button Click
  document.querySelectorAll("cart-remove-button a").forEach(function (removeButton) {
    removeButton.addEventListener("click", function (event) {
      event.preventDefault();
      fetch(this.href, { method: "GET" }) // Send GET request to remove item
        .then(() => location.reload()) // Reload page after item is removed
        .catch(error => console.error("Error removing item:", error));
    });
  });

  // Handle Quantity Change
  document.querySelectorAll(".cart-quantity").forEach(function (quantityInput) {
    quantityInput.addEventListener("change", function () {
      let form = this.closest("form");
      if (form) {
        let formData = new FormData(form);
        fetch(form.action, {
          method: "POST",
          body: formData,
        })
          .then(() => location.reload()) // Reload page after quantity update
          .catch(error => console.error("Error updating quantity:", error));
      }
    });
  });
});